import { useEffect } from 'react';

// Instagram's oEmbed script only auto-renders blockquotes present at load time,
// so newly added embeds need an explicit reprocess call.
const loadInstagramScript = () => {
    if (window.instgrm) {
        window.instgrm.Embeds.process();
        return;
    }
    if (document.getElementById('instagram-embed-script')) return;

    const script = document.createElement('script');
    script.id = 'instagram-embed-script';
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
};

const InstagramEmbed = ({ url }) => {
    useEffect(() => {
        loadInstagramScript();
        const timer = setTimeout(() => {
            if (window.instgrm) window.instgrm.Embeds.process();
        }, 400);
        return () => clearTimeout(timer);
    }, [url]);

    return (
        <blockquote
            className="instagram-media"
            data-instgrm-permalink={url}
            data-instgrm-version="14"
            style={{ background: '#FFF', border: 0, margin: '0 auto', maxWidth: 400, width: '100%', minWidth: 280 }}
        />
    );
};

export default InstagramEmbed;
